import { TAnswerState } from '../../../../containers/FormContainer/types/internal';

export const booleanMapper = (answerState: TAnswerState) => {
  return { [answerState.answerField]: answerState.value === 'yes' };
};
